import React from 'react';
import PropTypes from 'prop-types';

const SELECT_CLASS_NAMES = ['floating-label-submit', 'floating-label-submit'];

function Submit(props) {
    const buttonClassNames = ['floating-label-submit__button'];
    if (props['call-to-action']) {
        buttonClassNames.push('floating-label-submit__button--cta');
    }

    return (
        <div className={SELECT_CLASS_NAMES.join(' ')}>
            <button className={buttonClassNames.join(' ')} name={props.name} onClick={props.onSubmit} disabled={props.disabled}>
                {props.label}
            </button>
        </div>
    );
}

Submit.propTypes = {
    label: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    'call-to-action': PropTypes.bool,
};

export default Submit;
